import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { WorkingHours } from "@/types";

export const useWorkingHours = () => {
  const { data: workingHours = [], isLoading, refetch } = useQuery({
    queryKey: ['working-hours'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('working_hours')
        .select('*')
        .order('day_of_week', { ascending: true });

      if (error) throw error;
      return data as WorkingHours[];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    workingHours,
    isLoading,
    refetch,
  };
};
